// extracted by mini-css-extract-plugin
export var fileExt = "_s4-8";
export var fileIcon = "_s4-6";
export var fileLink = "_s4-5";
export var fileName = "_s4-7";
export var image = "_s4-1";
export var imageError = "_s4-3";
export var imageErrorIcon = "_s4-4";
export var imageLink = "_s4-0";
export var imageLoaded = "_s4-2";